// extracted by mini-css-extract-plugin
module.exports = {"FinishPage":"FinishPage_FinishPage__8dqGD","btn":"FinishPage_btn__30wZr","btnRetry":"FinishPage_btnRetry__WrCi-"};